/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

export default function Typography(theme: Theme): any {
  return {
    MuiTypography: {
      styleOverrides: {
        paragraph: { marginBottom: theme.spacing(2) },
        gutterBottom: { marginBottom: theme.spacing(1) },
      },
    },
  };
}
